module.exports = __webpack_public_path__ + "static/media/4419_1159205987048_4014492_n.6ceba443.jpg";